module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("lqOOm"))).then(() => parcelRequire('ljYL6'));